var _defs, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplaintManagementPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 776.57,
    height: 443.842,
    viewBox: "0 0 776.57 443.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M21.324,0H755.246c11.777,0,21.325,3.942,21.325,8.806V435.038c0,4.863-9.547,8.8-21.325,8.8H21.324C9.547,443.842,0,439.9,0,435.038V8.806C0,3.942,9.547,0,21.324,0Z",
    transform: "translate(295 118.748)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-295 -118.748)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12078",
    "data-name": "Group 12078",
    transform: "translate(260.08 62.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22070",
    "data-name": "Path 22070",
    d: "M324.5,304.3c-.406-5.539-1.9-10.586-7.729-10.129-1.566-10.351-7.081-22.945-12.311-20.823s-21.939,11.034-21.939,11.034-5.994-20.188-10.353-24.72-12.879-9.2-12.879-9.2l-10.312,8.353,6.99,15.873s5.125,12.075,1.175,24.6,5.433,23.923,5.1,25.074a17.4,17.4,0,0,0,2,14.953l1.267,13.171c-1.459-1.151-2.26-1.893-2.26-1.893s-1.79,47.541-3.089,84.049c-12.33-28.246-27.33-59.645-42.83-85.138-19.248-31.658-34.772-57.538-45.41-75.376q-.441-.738-.869-1.458l-.136-.227q-1.838-3.084-3.467-5.822l-.1-.163q-.332-.56-.656-1.1l-.208-.35q-1.425-2.4-2.668-4.491l.011-.009-.022-.01q-1.209-2.037-2.242-3.781c12.8-5.144,21.046-14.656,23.1-19.376-10-11-22-29.333-22-29.333l-.04-.058c.075-.51.152-1.033.229-1.573,2.259,1.379,4.744,2.309,6.477,1.3,4-2.334,7.667-12.334,3.667-16.334-2.383-2.383-5.83-.862-8.228.758,2.949-23.082,6.311-53.341,6.311-53.341s15.25-3.25,15.25-21.75c0-14.472-17-35-38.666-23.667s-44,44-44,44l-1.125,37.389A7.372,7.372,0,0,0,98,172c-6.667-1-12.667,7.333-11,14.667,1.311,5.768,9.22,8.646,14.97,6.855-.955,3.336-1.8,6.247-2.44,8.423-.324.148-.623.283-.863.388-.808,2.308-2.215,5.575-3.709,8.859l-.541.493-.146.131c-1.43,1.295-3.282,2.938-5.553,4.884l-.012.01c-6.916,5.926-17.679,14.632-31.989,24.68l-.282.2q-1.344.942-2.729,1.9l-.228.157q-4.389,3.03-9.186,6.193c-8.4,5.532-17.729,11.317-27.959,17.162-35.385,20.22-90.528,62.472-129,101.65V500H324.711c-2.434-29.267-10.2-114.009-20.076-133.993-.2.014-.4.016-.593.027l-2.167-12.423c.057-.028.119-.054.172-.083,3.925.476,15.157.523,16.88-3.036s.677-14.3.677-14.3a6.454,6.454,0,0,0,2.816-4.051c.916-3.118-1.9-13.835-1.9-13.835l3.279-1.476A65.8,65.8,0,0,0,324.5,304.3Z",
    fill: "#33437c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12077",
    "data-name": "Group 12077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22071",
    "data-name": "Path 22071",
    d: "M211.083,128.75s15.25-3.25,15.25-21.75c0-14.472-17-35-38.666-23.667s-44,44-44,44l-1.334,44.334,6.334,5Z",
    fill: "#192956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22072",
    "data-name": "Path 22072",
    d: "M211.083,128.75s-6,54-9,72.75c-5.25,6-63.75-5.5-63.75-5.5s11.5-38.5,13-49.5c5-1.25,6.75-10.75,9.25-16.75C166.083,131.75,205.833,132,211.083,128.75Z",
    fill: "#f0bf88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22073",
    "data-name": "Path 22073",
    d: "M146.333,173.667S144.667,163,138,162s-12.667,7.333-11,14.667,14,10,19,4.333S146.333,173.667,146.333,173.667Z",
    fill: "#f0bf88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22074",
    "data-name": "Path 22074",
    d: "M202,184.333s7-7,11-3,.333,14-3.667,16.334-12-5.667-12-5.667Z",
    fill: "#f0bf88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22075",
    "data-name": "Path 22075",
    d: "M137.833,198.5s-29,28.5-81.5,58.5-148.5,108.5-169,153.5V500h443s-35-98-73-160.5-61.5-102.5-61.5-102.5Z",
    fill: "#ae684f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22076",
    "data-name": "Path 22076",
    d: "M195.833,237l-58-38.5s-18.814,18.481-53.546,41.341C93.222,273.235,112.318,341.854,125.333,369c29.02-16.758,67.725-72.269,86.626-104.815C201.572,246.769,195.833,237,195.833,237Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22077",
    "data-name": "Path 22077",
    d: "M202.667,198s12,18.333,22,29.333c-3.334,7.667-23,28-52,21.667S129,213.667,129,213.667s7.333-14.667,9.667-21.334c5.333-2.333,32.333-16,45-10A49.763,49.763,0,0,1,202.667,198Z",
    fill: "#ae684f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22078",
    "data-name": "Path 22078",
    d: "M304.046,327.238l1.922,19.975,39.2,15.3-4.039-23.151Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22079",
    "data-name": "Path 22079",
    d: "M298.856,465.846c-.266-1.476,4.4-125.257,4.4-125.257s18.3,17.029,41.383,15.418C356.619,380.269,365.509,500,365.509,500H299.567Z",
    fill: "#ae684f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22080",
    "data-name": "Path 22080",
    d: "M302.244,314.358c.332-1.151-9.05-12.549-5.1-25.074s-1.175-24.6-1.175-24.6l-6.99-15.873,10.312-8.353s8.519,4.671,12.879,9.2,10.353,24.72,10.353,24.72,16.709-8.912,21.939-11.034,10.745,10.472,12.311,20.823c5.825-.457,7.323,4.59,7.729,10.129a65.8,65.8,0,0,1-.7,12.531l-3.279,1.476s2.814,10.717,1.9,13.835a6.454,6.454,0,0,1-2.816,4.051s1.046,10.74-.677,14.3-12.955,3.512-16.88,3.036C335.592,347.052,295.151,338.967,302.244,314.358Z",
    fill: "#f0bf88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22081",
    "data-name": "Path 22081",
    d: "M186.333,156.75s-2,17-1.75,24.25.25,11.25-2.5,11.5-4.5-9.75-3-17.25S186.333,156.75,186.333,156.75Z",
    fill: "#fc8a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22082",
    "data-name": "Path 22082",
    d: "M183.833,137.5s-10-2.25-17,4.75",
    fill: "none",
    stroke: "#33437c",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22083",
    "data-name": "Path 22083",
    d: "M194.033,141.691s10.085,1.83,13.8,11.007",
    fill: "none",
    stroke: "#33437c",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.75,
    cy: 3.5,
    rx: 1.75,
    ry: 3.5,
    transform: "translate(191.833 161.25)",
    fill: "#112144"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.75,
    cy: 3.5,
    rx: 1.75,
    ry: 3.5,
    transform: "translate(173.5 155.25)",
    fill: "#112144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22084",
    "data-name": "Path 22084",
    d: "M322.522,274.382c-1.144.206-6.014,4.331-6.014,4.331a76.964,76.964,0,0,0-.591,9.853c.228,2.912,3.215,4.738,3.215,4.738a135.225,135.225,0,0,0,37.64-9.133",
    fill: "none",
    stroke: "#d69350",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22085",
    "data-name": "Path 22085",
    d: "M319.132,293.3s-4.348,4.024-3.824,14.865c.325,6.735,25.891,2.727,45.214.138",
    fill: "none",
    stroke: "#d69350",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22086",
    "data-name": "Path 22086",
    d: "M320.034,311.454a5.7,5.7,0,0,0-3.469,5.349c-.189,3.874,1.155,8.063,9.394,9.534s33.645-.144,33.645-.144",
    fill: "none",
    stroke: "#d69350",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22087",
    "data-name": "Path 22087",
    d: "M321.7,325.627a9.245,9.245,0,0,0-3.154,3.816c-.784,2.209-1.523,7.954,5.338,9.969s18.166,4.116,18.166,4.116",
    fill: "none",
    stroke: "#d69350",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22088",
    "data-name": "Path 22088",
    d: "M175.583,204.5s-3.5,14.75-8.25,13.25-2.75-20-2.75-20",
    fill: "none",
    stroke: "#030d19",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22089",
    "data-name": "Path 22089",
    d: "M133.833,169S141,167,143,176.833c-2.667,0-3.333,2-.833,4.334",
    fill: "none",
    stroke: "#cc8246",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22090",
    "data-name": "Path 22090",
    d: "M137.833,169.417a10.012,10.012,0,0,0-4.666,5.75",
    fill: "none",
    stroke: "#cc8246",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_539",
    "data-name": "Line 539",
    x1: 1.333,
    y2: 13,
    transform: "translate(202.667 185)",
    fill: "none",
    stroke: "#cc8246",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22091",
    "data-name": "Path 22091",
    d: "M211.833,187.167s-3.666-2.667-8.5,3.666",
    fill: "none",
    stroke: "#cc8246",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22092",
    "data-name": "Path 22092",
    d: "M209,187s.833,3.833-.333,6.5",
    fill: "none",
    stroke: "#cc8246",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22093",
    "data-name": "Path 22093",
    d: "M121.333,213c0,1,7.334,46.333,7.334,46.333L157,247.667,169.667,277l34.166-26.5",
    fill: "none",
    stroke: "#a5a5a5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22094",
    "data-name": "Path 22094",
    d: "M158.833,264.219,141.99,257l3.781,19.594-25.437,56.031,7.219,24.063,17.188-16.5,2.75-62.906Z",
    fill: "#ee2f35"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_540",
    "data-name": "Line 540",
    x2: 12,
    y2: 72.5,
    transform: "translate(233.833 427.5)",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22095",
    "data-name": "Path 22095",
    d: "M66.333,252.5l-6,41.5,42,15",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22096",
    "data-name": "Path 22096",
    d: "M82.333,302.5l-12,30.5,75.5,79.5-20.5-43.5",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22097",
    "data-name": "Path 22097",
    d: "M219.833,278.5l-3.5,39-37.5-.5",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22098",
    "data-name": "Path 22098",
    d: "M194.333,317.5l3,28.5-66.5,34.5",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_541",
    "data-name": "Line 541",
    x1: 22.5,
    y2: 87.5,
    transform: "translate(123.333 412.5)",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22099",
    "data-name": "Path 22099",
    d: "M7.333,371s-35.5,81-47,129",
    fill: "none",
    stroke: "#0e1d3d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(121.333 422.5)",
    fill: "#0e1d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22100",
    "data-name": "Path 22100",
    d: "M215.333,91c5.621,3.106,8.345,11.561,6.675,17.583-.846-2.038-1.18-5.815-3.292-6.539-.073,1.4-.023,2.863-.106,4.263a21.365,21.365,0,0,0-2.885-3.529c-.1,1.451.143,2.907-.459,4.177-1.364-1.314-3.254-2.939-5.209-3.229a4.041,4.041,0,0,1-1.308,2.89c-1.452-2.817-3.162-1.364-5.374-.991a7.468,7.468,0,0,0,.674-4.265c.386.547,1.51,1.336,1.951,2.013,1.378-1.445,1.419-3.356,1.391-5.329,1.416.607,2.451,2.364,3.541,3.641.17-2.193,0-4.462.118-6.656,1.283.756,1.955,2.251,2.884,3.294.527-2.236-.665-3.847-1.592-5.637,1.327.728,2.181,2.183,3.341,3.2.3-2.269-1.348-3.72-1.292-5.839C215.785,90.7,217.375,92.456,215.333,91Z",
    fill: "#33437c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22101",
    "data-name": "Path 22101",
    d: "M187.667,83.333c-21.667,11.334-44,44-44,44l-1.125,37.389A7.372,7.372,0,0,0,138,162c-6.667-1-12.667,7.333-11,14.667,1.311,5.768,9.22,8.646,14.97,6.855-.955,3.336-1.8,6.247-2.44,8.423-.325.148-.623.283-.863.388-.808,2.308-2.215,5.575-3.71,8.859-.174.16-.35.32-.54.493l-.146.131c-1.43,1.295-3.282,2.938-5.553,4.884l-.012.01c-6.916,5.926-17.679,14.632-31.989,24.68l-.282.2q-1.344.942-2.729,1.9l-.228.157q-4.389,3.03-9.186,6.193c-8.4,5.532-17.729,11.317-27.959,17.162-52.5,30-148.5,108.5-169,153.5V500H-4.294c2.314-6.764,4.7-13.5,7.4-20.112,17.644-43.282,38.7-85.314,59.642-127.069,20.705-41.28,41.967-82.278,62.36-123.714a10.453,10.453,0,0,1,3.1-3.711,11.569,11.569,0,0,1,4.343-3.661c4.663-9.021,9.639-17.871,14.471-26.909,8.517-15.928,14.192-32.54,19.344-49.8,3.83-12.831,7.658-25.736,13.975-37.6,4.93-9.26,11.154-19.31,20.145-25.118a23.985,23.985,0,0,1,3.55-1.9A25.38,25.38,0,0,0,187.667,83.333Z",
    fill: "#33437c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(106.833 473.833)",
    fill: "#0e1d3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintManagementPopup);
export default __webpack_public_path__ + "static/media/complaint-management-popup.079f161d4826c83d904e24553e4efef9.svg";
export { ForwardRef as ReactComponent };